import { cn } from '@/lib/cn';

/**
 * The Nearmirer brand mark — the coral "glow" blob. One source of truth: use
 * this everywhere the logo appears (app + marketing chrome). It's an organic
 * squircle path (not a CSS `border-radius` blob) so the same shape can back the
 * favicon / PWA icon in `public/`. Fill follows `--color-accent` so it tracks
 * light/dark and the theme.
 */
export function Logo({ className, title = 'Nearmirer' }: { className?: string; title?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      role="img"
      aria-label={title}
      className={cn('inline-block', className)}
    >
      <path
        fill="var(--color-accent)"
        d="M16 1.8c5.6 0 9.4 2.3 11.6 6.2 2 3.6 2.4 8 .9 12-1.4 3.7-4.4 6.6-8.2 8-4 1.5-8.7 1.2-12.3-1C4 34.7 1.6 30.9.9 26.4.2 22 1.4 17.4 4.2 13.9 7 10.3 8.5 6.5 11 4.2 12.4 2.7 14 1.8 16 1.8Z"
      />
      <circle cx="16" cy="16" r="4.4" fill="var(--color-canvas)" opacity="0.22" />
    </svg>
  );
}
